<script setup lang="ts">
	import { XIcon } from "lucide-vue-next";
	import { onMounted, onUnmounted, ref } from "vue";

	defineProps({
		isVisible: {
			type: Boolean,
			default: false,
		},
	});
	const emit = defineEmits(["close"]);

	const sheet = ref();
	const translateY = ref(0);

	const close = () => {
		emit("close");
		translateY.value = 0;
	};

	const handleResize = (_?: UIEvent) => {
		if (sheet.value) {
			sheet.value.style.maxHeight = `${window.innerHeight * 0.9}px`;
		}
	};

	onMounted(() => {
		handleResize();
		window.addEventListener("resize", handleResize);
	});

	onUnmounted(() => {
		window.removeEventListener("resize", handleResize);
	});
</script>

<template>
	<div>
		<div
			v-if="isVisible"
			ref="sheet"
			class="z-10 !max-h-full fixed overflow-auto h-full inset-0 bg-rev1White rounded-t-2xl shadow-lg transition-transform duration-300 ease-out transform"
		>
			<div class="absolute top-0 left-0" @click="close">
				<XIcon class="cursor-pointer h-6 w-6 m-4" />
			</div>

			<div class="pt-4">
				<slot class="z-50"></slot>
			</div>
		</div>
	</div>
</template>

<style scoped></style>
